import CreateEditEmployee from "./CreateEditEmployee";

export default CreateEditEmployee;
